import { IsNotEmpty } from "class-validator";
import { DataValidationError } from "constants/DataValidationError";

export default class CancelOrderReq {
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  readonly orderId: number;
  constructor(arg: any) {
    arg = arg || {};
    this.orderId = arg.orderId;
  }
}
